import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/redux/store';

export const selectData = (state: RootState) => state.table.data;
export const selectEditableRows = (state: RootState) => state.table.editableRows;

export const selectRowEditMode = createSelector(
  [selectEditableRows, (_, rowIndex: number) => rowIndex],
  (editableRows, rowIndex) => editableRows[rowIndex] ?? false
);
